import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'
import { Zone } from '../../../interfaces'
import { IPickingRoute } from '../../../interfaces/PickingRoute/PickingRoute'
import {
  IPickingRouteState,
  IPickingRouteValidationState
} from '../../../interfaces/PickingRoute/PickingRouteState'
import { TypePickingRoute } from '../../../interfaces/PickingRoute/TypePickingRoute'
import { configDateInitial, utcToLocal } from '../../../utils/dateHelper'

export type PickingRouteAdminFilters = typeof pickingRouteinitialFilters

export const pickingRouteinitialFilters = {
  pickingRouteId: '',
  warehouseId: -1,
  zoneId: '',
  pickerId: 0,
  initialDate: configDateInitial(7),
  endDate: configDateInitial(0),
  pickingRouteStateId: 0,
  validationStatusId: 0,
  workOrderId: '',
  skuId: [] as string[],
  typePickingRouteId: '',
  validationUserId: 0,
  orderOriginId: -1,
  referenceId: '',
  lpn: ''
}

export const pickingRouteStates: IPickingRouteState[] = [
  {
    value: 1,
    name: 'No Iniciada'
  },
  {
    value: 2,
    name: 'Iniciada'
  },
  {
    value: 3,
    name: 'Terminada'
  }
]

export const pickingRouteValidationState: IPickingRouteValidationState[] = [
  {
    value: 3,
    name: 'Validada'
  },
  {
    value: 2,
    name: 'No Validada'
  }
]

export const getPickingRouteAdminHeaderConfiguration = (
  zones: Zone[],
  typesPickingRoute: TypePickingRoute[]
): TableHeaderConfigWithType<IPickingRoute>[] => [
  { field: 'pickingRouteId', title: 'Ruta' },
  { field: 'workOrderId', title: 'OT' },
  {
    title: 'Creada',
    field: 'createdAt',
    formater: (value) =>
      value
        ? utcToLocal(value as string, 'dd/MM/yyyy hh:mm:ss')
        : 'Sin fecha de creación'
  },
  {
    title: 'Iniciada',
    field: 'startedAt',
    formater: (value) =>
      value
        ? utcToLocal(value as string, 'dd/MM/yyyy hh:mm:ss')
        : 'No ha iniciado'
  },
  {
    title: 'Finalizada',
    field: 'endedAt',
    formater: (value) =>
      value
        ? utcToLocal(value as string, 'dd/MM/yyyy hh:mm:ss')
        : 'No ha finalizado'
  },
  {
    title: 'Zona',
    field: 'zoneId',
    formater: (value) => {
      const zone = zones.find((zone) => zone.zoneId === (value as number))
      return zone?.zoneName || 'Sin Zona'
    }
  },
  {
    title: 'Picking',
    field: 'pickingRouteStateId',
    formater: (value) =>
      pickingRouteStates.find((state) => value === state.value)?.name ||
      'Sin inicia'
  },
  {
    title: 'Validación',
    field: 'validationStatusId',
    formater: (value) =>
      pickingRouteValidationState.find((state) => value === state.value)
        ?.name || 'Sin validar'
  },
  { title: 'Picker', field: 'picker' },
  { title: 'LPN/TOTE', field: 'lpn' },
  {
    title: 'Tipo',
    field: 'typePickingRouteId',
    formater: (value) => {
      const type = typesPickingRoute.find(
        (type) => type.typePickingRouteId === (value as number)
      )
      return type?.name || 'Sin tipo'
    }
  }
]

export const pickingRouteTypesCantBeDeleted = [
  eTypePickingRoute.ExternalStorage,
  eTypePickingRoute.Venta_En_Verde
]
